import { StyleSheet } from 'react-native';
import { colors, spacing, fontWeights, borderRadius } from './theme';

export const styles = StyleSheet.create({
  shell: { 
    flex: 1, 
    flexDirection: 'column', 
    overflow: 'hidden' 
  },
  mobileContentContainer: {
    flex: 1,
    flexDirection: 'column',
    position: 'relative',
  },
  content: { 
    flex: 1, 
    minHeight: 0 
  },

  /* DESKTOP STYLES */
  desktopShell: {
    flex: 1,
    flexDirection: 'row',
    backgroundColor: '#0f172a',
    height: '100vh' as any,
  },
  sidebar: {
    width: 260,
    backgroundColor: '#003366',
    paddingVertical: spacing[6],
    paddingHorizontal: spacing[4],
    justifyContent: 'space-between',
    borderRightWidth: 1,
    borderRightColor: 'rgba(255, 255, 255, 0.05)',
    zIndex: 10,
  },
  sidebarBrand: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing[3],
    marginBottom: spacing[8],
    paddingHorizontal: spacing[2],
  },
  brandText: {
    fontSize: 20,
    fontWeight: fontWeights.bold,
    color: '#ffffff',
  },
  sidebarMenu: {
    flex: 1,
    gap: spacing[2],
  },
  sidebarItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing[3],
    paddingVertical: spacing[3],
    paddingHorizontal: spacing[4],
    borderRadius: borderRadius.DEFAULT,
    backgroundColor: 'transparent',
    cursor: 'pointer' as any,
  },
  sidebarItemActive: {
    backgroundColor: 'rgba(255,255,255,0.08)',
  },
  sidebarItemText: {
    fontSize: 14,
    fontWeight: '500',
    color: '#cbd5e1',
  },
  sidebarItemActiveText: {
    color: '#ffffff',
    fontWeight: fontWeights.bold,
  },
  sidebarLogout: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing[3],
    paddingVertical: spacing[3],
    paddingHorizontal: spacing[4],
    borderRadius: borderRadius.DEFAULT,
    borderWidth: 1,
    borderColor: 'rgba(239, 68, 68, 0.2)',
  },
  logoutText: {
    fontSize: 14,
    fontWeight: fontWeights.bold,
    color: '#f87171',
  },
  desktopContent: {
    flex: 1,
    flexDirection: 'column',
    backgroundColor: '#f5f7fa',
  },
  desktopHeaderCompact: {
    height: 42,
    backgroundColor: '#ffffff',
    borderBottomWidth: 1,
    borderBottomColor: '#e2e8f0',
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: spacing[2],
  },
  headerLeftSection: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  hamburgerBtn: {
    paddingHorizontal: spacing[1.5],
    paddingVertical: spacing[1],
    justifyContent: 'center',
    alignItems: 'center',
  },
  dividerVertical: {
    width: 1,
    height: 20,
    backgroundColor: '#e2e8f0',
    marginHorizontal: spacing[1.5],
  },
  avatarBadgeCircle: {
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: '#00A651',
    justifyContent: 'center',
    alignItems: 'center',
  },
  avatarBadgeText: {
    color: '#ffffff',
    fontSize: 10,
    fontWeight: fontWeights.bold,
  },
  breadcrumbContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: spacing[1],
  },
  breadcrumbParentText: {
    fontSize: 13,
    color: '#475569',
    fontWeight: fontWeights.regular,
  },
  breadcrumbChevron: {
    marginHorizontal: 4,
  },
  breadcrumbCurrentText: {
    fontSize: 13,
    color: '#0f172a',
    fontWeight: fontWeights.bold,
  },
  desktopHeaderActions: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing[2],
  },
  headerActionBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingHorizontal: spacing[1.5],
    paddingVertical: 4,
  },
  headerActionText: {
    fontSize: 12,
    color: '#475569',
  },
  headerReminderPillCompact: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingHorizontal: spacing[2],
    paddingVertical: 3,
    borderRadius: borderRadius.full,
    backgroundColor: '#EDF1F5',
    borderWidth: 1,
    borderColor: '#e2e8f0',
    position: 'relative',
  },
  reminderBadgeDotCompact: {
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: colors.tertiary,
  },
  headerReminderTextCompact: {
    fontSize: 12,
    fontWeight: fontWeights.semibold,
    color: colors.primary,
  },
  /* Sidebar collapsed styles */
  sidebarCollapsed: {
    width: 72,
    paddingHorizontal: spacing[2],
  },
  sidebarBrandCentered: {
    justifyContent: 'center',
    paddingHorizontal: 0,
    gap: 0,
  },
  sidebarItemCentered: {
    justifyContent: 'center',
    paddingHorizontal: 0,
    gap: 0,
  },
  sidebarToggleBottom: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing[3],
    paddingVertical: spacing[3],
    paddingHorizontal: spacing[4],
    borderRadius: borderRadius.DEFAULT,
    marginBottom: spacing[2],
  },
  toggleText: {
    fontSize: 13,
    color: '#94a3b8',
    fontWeight: fontWeights.medium,
  },
  sidebarLogoutCentered: {
    justifyContent: 'center',
    gap: 0,
    paddingHorizontal: 0,
  },
  desktopMain: {
    flex: 1,
    minHeight: 0,
  },
});
